import React, { useEffect, useState } from "react";
import "./styles/index.scss";
import Delimiter from "../../common/forms/delimiter/Delimiter";
import Button from "../../common/forms/button";
import Actions from "../../../actions";
import { connect } from "react-redux";
import { clickToLinkHandler } from "../../../helpers/utils";
import DKFormTextInput from "../../common/widgets/formVariablesWidget/DKFormTextInput";

const RegisterForm = (props) => {
  const { register, errors, registered } = props;

  const [member, setMember] = useState({
    first_name: undefined,
    last_name: undefined,
    email: undefined,
    company: undefined,
  });

  useEffect(() => {
    if (registered) {
      clickToLinkHandler("/activate");
    }
  }, [registered]);

  useEffect(() => {
    if (
      errors &&
      errors.email &&
      errors.email ===
        "This email already exists, but account still not activated"
    ) {
      clickToLinkHandler("/send-activation-link/" + member.email);
    }
  }, [errors]);

  const handleChange = (e) => {
    setMember({ ...member, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      register(member);
    }
  };

  return (
    <React.Fragment>
      <div className="register-form-container">
        <div className="title">Registration</div>
        <Delimiter type="headline" shift="18" />
        <div className="field-container">
          <div className="form-input-container">
            <DKFormTextInput
              className={(errors && errors.firstName && "error") || ""}
              dataTestId="registration-first-name"
              label="First Name"
              name="first_name"
              type="text"
              required
              onChange={handleChange}
              value={member.first_name}
              onKeyDown={handleSubmit}
            />
            {errors && errors.firstName && (
              <p className="error">{errors.firstName}</p>
            )}
          </div>
          <div className="shift-20" />
          <div className="form-input-container">
            <DKFormTextInput
              className={(errors && errors.lastName && "error") || ""}
              dataTestId="registration-last-name"
              label="Last Name"
              name="last_name"
              type="text"
              required
              onChange={handleChange}
              value={member.last_name}
              onKeyDown={handleSubmit}
            />
            {errors && errors.lastName && (
              <p className="error">{errors.lastName}</p>
            )}
          </div>
        </div>
        <div className="form-input-container">
          <DKFormTextInput
            className={(errors && errors.email && "error") || ""}
            dataTestId="registration-email"
            label="Email"
            name="email"
            type="text"
            required
            onChange={handleChange}
            value={member.email}
            onKeyDown={handleSubmit}
          />
          {errors && errors.email && <p className="error">{errors.email}</p>}
        </div>
        <div className="form-input-container">
          <DKFormTextInput
            dataTestId="registration-company-name"
            label="Company Name"
            name="company"
            type="text"
            required
            onChange={handleChange}
            value={member.company}
            onKeyDown={handleSubmit}
          />
          {errors && errors.name && <p className="error">{errors.name}</p>}
        </div>
        <Delimiter type="internal" shift="18" />
        <Button
          type="primary"
          size="large"
          children={"Create a new account"}
          onClick={handleSubmit}
        />
        <div className="links-container center-block">
          <div
            className="link"
            onClick={() => {
              clickToLinkHandler("/");
            }}
          >
            Already have an account? Sign In
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  const { formErrors: errors, registered } = state.auth;

  return {
    errors,
    registered,
  };
};

const mapDispatchToProps = (dispatch) => ({
  register: function (data) {
    dispatch(Actions.register(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm);
